import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";
import { ellipsesOverflow } from "@/styles/helper";

export const searchContainer = css({
  position: "relative",
});

export const searchInput = css({
  padding: "0.5rem 0.75rem",
});

export const searchResultContainer = (theme: Theme) =>
  css({
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    zIndex: 1000,
    borderRadius: "0.25rem",
    width: "100%",
    marginTop: "0.5rem",
    maxHeight: "50vh",
    overflowY: "auto",
    boxShadow: theme.boxShadows.popoverBase,
  });

export const searchResultGroup = css({
  paddingBottom: "1rem",
  position: "relative",
});

export const searchResultGroupName = (theme: Theme) =>
  css({
    padding: "0.5rem 1rem",
    backgroundColor: theme.system.backgroundBox,
    textTransform: "uppercase",
    borderBottom: "1px solid",
    borderColor: theme.system.borderBase,
    position: "sticky",
    top: 0,
    zIndex: 1000,
  });

export const searchResultLink = (theme: Theme) =>
  css({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    border: "none",
    width: "100%",
    padding: "0.5rem 1rem",
    textDecoration: "none",
    color: theme.system.textBase,
    ":hover": {
      color: theme.system.textBase,
      backgroundColor: theme.system.backgroundMutedHover,
    },
  });

export const searchResultTitle = (theme: Theme) =>
  css({
    display: "block",
    color: theme.system.textActive,
    ...ellipsesOverflow,
  });

export const searchResultHierarchy = css({
  display: "block",
  fontSize: typography.sizeSmall,
  ...ellipsesOverflow,
});
